export enum EBuildingStatus {
  Old = 1,
  New = 2,
}
